import React, { Component } from 'react'
import MappingSpecieList from '../../../components/MappingSpecieList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingSpecieConsumer } from '../../../context/MappingSpecieContext'

type MappingSpecieProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingSpecie extends Component<MappingSpecieProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingSpecieConsumer>
        {({ fetching, mappingSpecies, pagination, requestMappingSpecieList }) => {

          return <MappingSpecieList permissions={permissions} loading={fetching} mappingSpecies={mappingSpecies} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingSpecies={requestMappingSpecieList} />
        }}
      </MappingSpecieConsumer>
    )
  }
}
